import React, { useContext } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BsPinMapFill, BsPhone, BsEnvelope } from "react-icons/bs";
import { FaUtensils, FaBuilding, FaPeopleCarry } from "react-icons/fa";
import DonateButton from "../components/Donate";
import Anna1 from "../assets/Annachatra01.JPG";
import Anna2 from "../assets/Annachatra02.JPG";
import Anna3 from "../assets/annachtra.png";
import Anna4 from "../assets/annachatra03.JPG";
import "./AnnaChatra.css"; // dedicated CSS for Anna Chatra
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import Header from "../components/Layout/Header";

const translations = {
  en: {
    header: "Anna Chatra – Free Food Distribution",
    aboutTitle: "About Anna Chatra",
    aboutDesc:
      "At Shree Gurupeeth, the “Anna Chatra” (free food distribution hall) is a well-equipped and spacious facility. Devotees visiting the hall first get a glimpse of the charming southern-style idol of Goddess Annapurna. The building spans 65,000 sq. ft., with two floors including the ground floor. It houses a fully modern and well-equipped kitchen, cold storage, and solar-powered food preparation to save fuel. Grains are stored scientifically in a sterilized godown, and an electric lift transports prepared food to the upper floor. The first floor has a grand hall where up to 1,000 people can enjoy meals simultaneously. Seating is arranged separately for men and women, allowing everyone to partake independently. The hall is airy, well-lit, and designed with modern technology. You can also participate in this noble food donation service.",
    stats: [
      "Modern, fully equipped kitchen and cold storage",
      "Two-floor building with 65,000 sq. ft. built-up area",
      "Grand hall accommodates 1,000 people with separate seating for men and women"
    ],
    contactTitle: "Contact Info",
    address: "Shree Gurupeeth, Trimbakeshwar, Nashik, Maharashtra, India – 422212",
    phone: "+91 2594 234253 / 54",
    email: "annaChatra@gurupeeth.in",
    gallery: "Gallery",
    view: "View",
    home: "Home"
  },
  mr: {
    header: "अन्नछत्र – मोफत भोजन वितरण",
    aboutTitle: "अन्नछत्र बद्दल",
    aboutDesc:
      "श्री गुरुपिठाच्या अन्नछत्र या महत्वाच्या विभागाचे व्याप्त व सुसज्ज स्वरूप तयार झाले आहे. प्रसादालयात येणाऱ्या भाविकांना प्रथम अन्नपूर्णा मातेच्या दाक्षिणात्य पद्धतीची, मनमोहक मूर्तीचे दर्शन लाभते. अन्नछत्राची इमारत ६५००० चौरस मीटर क्षेत्रफळासह, दोन मजले (ग्राउंडसहित) बांधलेली आहे. अद्ययावत, सुसज्ज किचन, कोल्ड स्टोरेज व सौरऊर्जेवर अन्नाची निर्मिती करण्यात येते. अन्नधान्याची साठवण निर्जंतुकीकरण केलेल्या गोदामात होते व तयार झालेले अन्न दुसऱ्या मजल्यावर विद्युत लिफ्टने नेले जाते. पहिल्या मजल्यावर एक भव्य हॉल असून, एका वेळी १ हजार लोक भोजन घेऊ शकतात. स्त्री व पुरुषांसाठी स्वतंत्र आसन व्यवस्था आहे. हॉल हवेशीर, प्रकाशमान व अत्याधुनिक तंत्रज्ञानाने सजलेला आहे. आपणही या अन्नदानामध्ये सहभागी होऊ शकता.",
    stats: [
      "अद्ययावत व सुसज्ज किचन आणि कोल्ड स्टोरेज",
      "६५००० चौरस मीटर क्षेत्रफळासह दोन मजले बांधकाम",
      "भव्य हॉल, १ हजार लोकांसाठी स्वतंत्र आसन व्यवस्था स्त्री व पुरुषांसाठी"
    ],
    contactTitle: "संपर्क माहिती",
    address: "श्री गुरुपिठ, त्रिंबकेश्वर, नाशिक, महाराष्ट्र, भारत – ४२२२१२",
    phone: "+९१ २५९४ २३४२५३ / ५४",
    email: "annaChatra@gurupeeth.in",
    gallery: "गॅलरी",
    view: "पहा",
    home: "मुख्यपृष्ठ"
  }
};

export default function AnnaChatra() {
  const { lang } = useContext(LanguageContext);
  const t = translations[lang];

  const images = [Anna1, Anna2, Anna3, Anna4]; // Sample images

  return (
    <div className="annachattra-page">
      {/* Header + Breadcrumb */}
      <div className="annachattra-header-wrapper">
        <Header />
        <header className="annachattra-header">
          <div className="header-center">
            <div className="breadcrumb">
            <Link to="/">{t.home}</Link>  &gt;  <span>{t.header}</span>
            </div>
            <h1>{t.header}</h1>
          </div>
        </header>
      </div>

      {/* Main Info */}
      <main className="annachattra-main">
        <div className="info-video-container">
          <div className="annachattra-info-left">
            <h2>{t.aboutTitle}</h2>
            <p>{t.aboutDesc}</p>

            <div className="annachattra-stats">
              <div className="stat-card">
                <FaUtensils className="stat-icon" />
                <p>{t.stats[0]}</p>
              </div>
              <div className="stat-card">
                <FaBuilding className="stat-icon" />
                <p>{t.stats[1]}</p>
              </div>
              <div className="stat-card">
                <FaPeopleCarry className="stat-icon" />
                <p>{t.stats[2]}</p>
              </div>
            </div>

            <h3>{t.contactTitle}</h3>
            <div className="contact-info-cards">
              <div className="contact-card">
                <BsPinMapFill className="icon icon-address" />
                <div><p>{t.address}</p></div>
              </div>

              <div className="contact-card">
                <BsPhone className="icon icon-phone" />
                <div><p>{t.phone}</p></div>
              </div>

              <div className="contact-card">
                <BsEnvelope className="icon icon-email" />
                <div><p>{t.email}</p></div>
              </div>
            </div>

            <div className="annachattra-buttons">
              <Link to="/donation">
                <DonateButton />
              </Link>
            </div>
          </div>
        </div>

  {/* Gallery Section */}
<section className="annachattra-gallery">
  <h2>{t.gallery}</h2>
  <Slider
    className="gallery-slider"
    dots={true}
    infinite={true}
    speed={500}
    slidesToShow={3}
    slidesToScroll={1}
    arrows={images.length > 1}
    responsive={[
      {
        breakpoint: 1024, // tablets
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 600, // mobile
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ]}
  >
    {images.map((img, i) => (
      <div key={i} className="gallery-item">
        <img src={img} alt={`Anna Chatra ${i + 1}`} />
        <div className="gallery-overlay">{t.view}</div>
      </div>
    ))}
  </Slider>
</section>

      </main>
    </div>
  );
}
